@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-paginator {
    display: flex;
    flex-wrap: wrap;
    justify-content: var(--justify-content);
    column-gap: var(--content-spacing);
    row-gap: 1.5em;
    margin-bottom: 1em;

    // ==== Page Navigation

    .page-navigation {
      flex: 1 0 100%;
      display: flex;
      justify-content: var(--justify-content);
      align-items: center;
      order: 1;

      @include screen-lg {
        flex: 0 1 auto;
        justify-content: initial;
        order: var(--content-order-navigation);
      }
    }

    // == Nav List & Nav Button List

    .page-nav-list,
    .nav-button-list {
      display: flex;
      list-style-type: none;
      padding: 0;
      margin: 0;
    }

    .page-nav-list {
      column-gap: 0.5em;
    }

    .nav-button-list {
      column-gap: var(--nav-button-spacing);
      padding-left: 0.75em;
      padding-right: 0.75em;
    }

    // ==== Navigation Control & Number Button Containers

    .page-nav-control,
    .page-nav-item {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // ==== Number Buttons & Ellipsis

    .page-nav-button,
    .page-nav-ellipsis {
      min-width: var(--nav-button-size);
      line-height: normal;
    }

    // == Number Buttons

    .page-nav-button {
      @include button-reset;
      height: var(--nav-button-size);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: calc(var(--nav-button-size) / 2);
      position: relative;

      @include transition(
        $properties: 'background-color, font-weight, color',
        $duration: short
      );

      &:hover:not(.page-selected),
      &:focus:not(.page-selected) {
        outline: none;
        background-color: var(--nav-button-hover-background-color);
      }

      &.page-selected {
        font-weight: $font-weight-bold;
        cursor: default;
      }
    }

    // == Ellipsis (e.g. "...")

    .page-nav-ellipsis {
      align-self: center;
      text-align: center;
    }

    // ==== Page Size Select

    .page-size-select {
      display: flex;
      align-items: center;
      order: 2;
      column-gap: 0.5em;
      line-height: normal;
      margin-right: var(--size-select-margin-right);

      @include screen-lg {
        order: var(--content-order-size-select);
      }

      fluid-select {
        min-width: 50px;
      }
    }

    // ==== Page Range Indicator

    .page-range-indicator {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      order: 3;
      font-size: inherit;
      line-height: normal;
      color: var(--range-indicator-text-color);

      @include screen-lg {
        order: var(--content-order-range-indicator);
      }

      .page-range {
        white-space: nowrap;
      }
    }
  }
}
